var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-top-offer p-2 mb-2 text-center"},[_c('p',{staticClass:"mt-3 mb-3"},[_vm._v("Online gambling is not available in this state. We have more information on why:")]),_vm._v(" "),_c('a',{staticClass:"button-ghost-black mb-3",attrs:{"href":_vm.homepageLink}},[_vm._v("Online Gambling in "+_vm._s(_vm.state))])])
}
var staticRenderFns = []

export { render, staticRenderFns }